import { render, staticRenderFns } from "./EditOppoStaff.vue?vue&type=template&id=22df2b60&scoped=true&"
import script from "./EditOppoStaff.vue?vue&type=script&lang=js&"
export * from "./EditOppoStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditOppoStaff.vue?vue&type=style&index=0&id=22df2b60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df2b60",
  null
  
)

export default component.exports